$(function () {
    // パスワード忘れ画面で、emailが入力されたら、送信ボタンを有効化
    $('#PasswordForget input').on('input', function() {
        const email = $('#gym_user_email').val();
        if ( email ) {
            $('input[type="submit"]').prop('disabled', false);
        } else {
            $('input[type="submit"]').prop('disabled', true);
        }
    });
});